/**
 * @sahaj/config
 *
 * Environment configuration for Sahaj Connect.
 * Values are read from environment variables at runtime.
 * Never put secrets here — only URLs and non-sensitive config.
 */

function getApiBaseUrl(): string {
  try {
    // @ts-ignore
    if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_BASE_URL) {
      // @ts-ignore
      return import.meta.env.VITE_API_BASE_URL;
    }
  } catch (e) {
    // Ignore error in non-Vite environments
  }
  if (typeof globalThis !== 'undefined' && 'process' in globalThis) {
    const proc = (globalThis as { process?: { env?: Record<string, string | undefined> } }).process;
    const value = proc?.env?.['VITE_API_BASE_URL'];
    if (value) return value;
  }
  return 'https://apis.sahajconnect.hutechsolutions.in/api/v1';
}

function getWsUrl(): string {
  try {
    // @ts-ignore
    if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_WS_URL) {
      // @ts-ignore
      return import.meta.env.VITE_WS_URL;
    }
  } catch (e) {
    // Ignore error in non-Vite environments
  }
  if (typeof globalThis !== 'undefined' && 'process' in globalThis) {
    const proc = (globalThis as { process?: { env?: Record<string, string | undefined> } }).process;
    const value = proc?.env?.['VITE_WS_URL'];
    if (value) return value;
  }
  return 'wss://apis.sahajconnect.hutechsolutions.in/ws';
}

export const config = {
  api: {
    /**
     * Base URL for the Spring Boot REST API.
     * Example: https://apis.sahajconnect.hutechsolutions.in/api/v1
     */
    baseUrl: getApiBaseUrl(),
  },
  ws: {
    /**
     * WebSocket endpoint.
     * Example: wss://apis.sahajconnect.hutechsolutions.in/ws
     */
    url: getWsUrl(),
  },
  auth: {
    /** Access token TTL in milliseconds (15 min — matches backend) */
    accessTokenTtlMs: 15 * 60 * 1000,
    /** Threshold before expiry to proactively refresh (2 min) */
    refreshThresholdMs: 2 * 60 * 1000,
  },
  pagination: {
    /** Default page size for message history */
    defaultMessageLimit: 50,
    /** Maximum page size for synchronization requests */
    maxSyncLimit: 100,
  },
  ws_reconnect: {
    /** Initial backoff delay in ms */
    initialDelayMs: 1000,
    /** Backoff multiplier */
    multiplier: 2,
    /** Maximum backoff delay in ms (30 seconds) */
    maxDelayMs: 30_000,
  },
} as const;

export type Config = typeof config;
